import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageJA() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AIによる関係分析 | 有害なパターンとガスライティングを検出" description="元パートナーが問題かどうかを調べましょう。チャットをToxicDetectorのAIにアップロードして、操作、ガスライティング、危険信号を即座に機密分析。今すぐ無料スキャンを開始。" keywords="AI関係分析, 有害なパターン検出, ガスライティング検出器, 有害な元パートナー, 操作チェック, 関係の毒性, AIテキストスキャナー" canonical="https://toxicdetector.com/ja" language="ja" alternateUrls={alternateUrls} data-id="element-7625" data-mp="3vikhp8hijs7r" />
      <GoogleTranslateWidget data-id="element-7626" data-mp="36zs555qvfvzn" />
      <PromoBanner data-id="element-7627" data-mp="370lhcm8lndp6" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7628" data-mp="3bx21l5coh7wz">
        <Header data-id="element-7629" data-mp="3hs7okixz90a" />
        <main data-id="element-7630" data-mp="3h8nex5tk8j3">
          <HeroSection h1Override={<>
                あなたの脳は{' '}
                <span className="relative inline-block" data-id="element-7632" data-mp="8fa5pfvf83ti">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-7633" data-mp="3pxcv6g5dh0lu">
                    嘘
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-7634" data-mp="3uu3av2d9lu6q" />
                </span>{' '}
                をついている。
                <br data-id="element-7635" data-mp="r8nwd8s3po3b" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-7636" data-mp="r8xl6t1etp7f">
                  AIは嘘をつかない。
                </span>
              </>} data-id="element-7631" data-mp="3ithyms4vrgy" />
          <TrustSection data-id="element-7637" data-mp="26y58g6unntpr" />
          <FeaturesSection data-id="element-7638" data-mp="2lnbfui3ncq8q" />
          <GuaranteesSection data-id="element-7639" data-mp="2lnkvpcuz9h0p" />
          <ToolsSection data-id="element-7640" data-mp="2lmrxj0a33zu6" />
          <ComparisonSection data-id="element-7641" data-mp="2lp4cd4kjpu30" />
          <PricingSection data-id="element-7642" data-mp="2gnorbcidbnkm" />
          <FAQSection data-id="element-7643" data-mp="2gpjcmrxjxhp8" />
          <CTASection data-id="element-7644" data-mp="2gp0421tsk5nv" />
        </main>
        <Footer data-id="element-7645" data-mp="1sydwscrm2pex" />
      </div>
    </>;
}